import { Injectable } from '@angular/core';
import { Globals } from '../../../environments/Globals';
import { CommonConstant } from '../constent/applicationcodes';

export interface HeaderMenuLink {
    labelKey: number;
    path: string;
    qsParameters: string;
    menuIcon: string;
    sectionKey: number;
}

export interface HeaderMenuSection {
    labelKey: number;
    menuIcon: string;
    links: HeaderMenuLink[];
}

@Injectable()
export class HeaderMenuService {
    private commonconstant = new CommonConstant();
    private flatLinks: HeaderMenuLink[] = [];
    private sections: HeaderMenuSection[] = [];

    constructor(private globals: Globals) { }

    loadMenus(): void {
        this.flatLinks = [];
        this.sections = [];

        const menuJson = this.globals.getDataFromLocalStorage(this.commonconstant.AllowedMenus);
        if (!menuJson) {
            return;
        }

        const menu = JSON.parse(menuJson);
        const currentModuleId = Number(this.globals.getDataFromLocalStorage(this.commonconstant.CurrentModuleID));
        const tree = this.parseFlatArrayToTreeArray(menu);
        const modules = tree.filter(function (x) { return x.ModuleID === currentModuleId; });

        if (modules.length === 0 && tree.length > 0) {
            modules.push(tree[0]);
        }

        modules.forEach(function (module) {
            if (!module.Child) {
                return;
            }

            module.Child.forEach(function (section) {
                const sectionLinks: HeaderMenuLink[] = [];

                if (section.Child && section.Child.length > 0) {
                    section.Child.forEach(function (page) {
                        if (page.Path) {
                            const link: HeaderMenuLink = {
                                labelKey: page.StringNumber,
                                path: page.Path,
                                qsParameters: page.QSParameters || '',
                                menuIcon: section.MenuIcon || page.MenuIcon || 'micon-00.svg',
                                sectionKey: section.StringNumber
                            };
                            sectionLinks.push(link);
                            this.flatLinks.push(link);
                        }
                    }, this);
                } else if (section.Path) {
                    const link: HeaderMenuLink = {
                        labelKey: section.StringNumber,
                        path: section.Path,
                        qsParameters: section.QSParameters || '',
                        menuIcon: section.MenuIcon || 'micon-00.svg',
                        sectionKey: section.StringNumber
                    };
                    sectionLinks.push(link);
                    this.flatLinks.push(link);
                }

                if (sectionLinks.length > 0) {
                    this.sections.push({
                        labelKey: section.StringNumber,
                        menuIcon: section.MenuIcon || 'micon-00.svg',
                        links: sectionLinks
                    });
                }
            }, this);
        }, this);
    }

    getFlatLinks(): HeaderMenuLink[] {
        return this.flatLinks;
    }

    getSections(): HeaderMenuSection[] {
        return this.sections;
    }

    private parseFlatArrayToTreeArray(list: any[]): any[] {
        const treeArray = list.filter(function (x) { return x.PageLevel === 0 && x.IsParent === 1; });

        treeArray.forEach(function (element) {
            element.Visible = false;
            element.Child = list.filter(function (x) { return x.ParentID === element.PageID && x.PageLevel === 1; });

            element.Child.forEach(function (childElement) {
                childElement.Child = list.filter(function (x) { return x.ParentID === childElement.PageID && x.PageLevel === 2; });
                if (childElement.Child && childElement.Child.length > 0) {
                    element.Visible = true;
                }
            });
        });

        return treeArray;
    }
}
